import { NavLink, useLocation } from 'react-router-dom';

export default function SectionServices5({ data }) {
  return (
    <div className='section-full p-t120 p-b90 site-bg-gray tw-service-gallery-style4-area tyre-mark-bg'>
      <div className='services-gallery-block-outer2'>
        <div className='container'>
          {/* TITLE START */}
          <div className='section-head center wt-small-separator-outer'>
            <div className='wt-small-separator site-text-primary'>
              <div>{data?.title}</div>
            </div>
            <h2 className='wt-title'>{data?.subtitle}</h2>
            <p className='section-head-text'>{data?.description}</p>
          </div>
          {/* TITLE END */}
          <div
            className='section-content'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              className='services-gallery-style4'
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                width: '90%',
              }}
            >
              {Array.isArray(data?.services) && data.services.length > 0 ? (
                data.services.map((svc, index) => (
                  <div
                    key={index}
                    className='service-box-style4 col-xl-4 col-lg-4 col-md-6'
                  >
                    <div className='service-content'>
                      <div className='service-content-inner'>
                        <div className='service-content-top'>
                          <h3 className='service-title-large'>
                            <NavLink to={svc.link || '/services/detail'}>
                              {svc.title}
                            </NavLink>
                          </h3>
                        </div>
                        <div className='service-content-bottom'>
                          <span className='service-title-large-number'>
                            {svc.serial}
                          </span>
                          <p>{svc.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className='col-12'>
                  <p>No services available at the moment.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='tw-hilite-text-wrap'>
        <div className='tw-hilite-text right'>
          <span>{data?.main}</span>
        </div>
      </div>
    </div>
  );
}
